import { render, staticRenderFns } from "./importanceAnalysis.vue?vue&type=template&id=72b06b3c&scoped=true&"
import script from "./importanceAnalysis.vue?vue&type=script&lang=js&"
export * from "./importanceAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./importanceAnalysis.vue?vue&type=style&index=0&id=72b06b3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b06b3c",
  null
  
)

export default component.exports